module.exports = __webpack_public_path__ + "components/rewards/sixt/static/logo-388d7ec3ef786b03b1baf425584cee4a.jpg";